module.exports = __webpack_public_path__ + "ba99469b8ce7a24f6c05706e08850a41.svg";